<template>
    <Modal class="order-outstanding-balance-modal"
           icon="fa-coins"
           title="ORDER_OUTSTANDING_BALANCE.MODAL_TITLE">
        <div>
            <div class="alert alert-danger">
                {{ l('ORDER_OUTSTANDING_BALANCE.MESSAGE', { amount: order.getRemainingBalance()}) }}
            </div>
            <h4>{{ l('ORDER_OUTSTANDING_BALANCE.ORDER_SUMMARY') }}</h4>
            <OrderPreviewLines :lines="order.getLines()"
                               :show-line-prices="false" />
        </div>

        <template v-slot:footer>
            <div class="modl-footer">
                <!-- Left button -->
                <SquareBtn size="lg"
                           class="cancel-btn"
                           @click="resolve(false)">
                    {{ l('ORDER_OUTSTANDING_BALANCE.CONTINUE_WITHOUT_PAYMENT') }}
                </SquareBtn>

                <!-- Right button -->
                <SquareBtn color="danger"
                           size="lg"
                           @click="resolve(true)">
                    {{ l('ORDER_OUTSTANDING_BALANCE.PAY_BALANCE', { amount: order.getRemainingBalance()}) }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import DateFormat from '@/lib/Dates/DateFormat';
import Modal from '@/vue/components/Modals/Modal';
import OrderPreviewLines from '@/epos/vue/modals/OrderPreview/OrderPreviewLines';
import SquareBtn from '@/vue/components/SquareBtn';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'OrderOutstandingBalanceModal',

    components: { Modal, OrderPreviewLines, SquareBtn },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        /**
         * @type {Order}
         */
        order: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            DateFormat,
        };
    },
};
</script>
